export default function About() {
  return (
    <section id="about">
      <h2 style={{ fontSize: 36 }}>About Me</h2>

      <div className="glass" style={{ padding: 30, marginTop: 20 }}>
        <p style={{ color: "#cbd5e1", lineHeight: 1.7 }}>
          I am a Full Stack Developer specializing in React, Python, and cloud
          systems. I enjoy building scalable, elegant, and high-performance web
          applications with modern UI/UX.
        </p>
      </div>
    </section>
  );
}